import React, { useCallback, useState } from 'react';
// import PropTypes from 'prop-types';

import api from '../api';
import { Provider as name } from '../config';
import { formatData } from '../../providersHelpers';
import { useGet, useGetById, useGetSchema, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';

import Context from './context';
interface Props {
    children: React.ReactNode;
}

const CrmActionsProvider = ({ children }: Props) => {
    const [data, setData] = useState({ ids: [], byId: {} });
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res) => {
        setData(formatData(res));
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const getSchema = useGetSchema(api, schema, setSchema, setError);

    const handleSetData = useCallback((item, newData) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id, newData) => {
        setData(newData);
        setSelected({});
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete
            }}
        >
            {children}
        </Context.Provider>
    );
};

// CrmActionsProvider.propTypes = {
//     children: PropTypes.element.isRequired
// };

export default CrmActionsProvider;
